<template>
<div class="chapter">
<div class="inner_page">
<p class="pn"><span epub:type="pagebreak" id="page_1" title="1"><a href="#/contenttoc#pz5-4" id="pz5-4_1">PART I</a></span></p>
<p class="pt"><a href="#/contenttoc#pz5-4">LAYING THE GROUNDWORK</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?46b2ee0f